<template>
    <div class="commentList">
        <div class="commentItem marginT24" v-for="dataItem in dataList">
            <div class="flexLayout" style="line-height: 36px;">
                <div style="width: 24px;">
                    <img style="vertical-align: text-bottom;" width="24" height="24" :src="dataItem.userHead" class="size24 circle"/>
                </div>
                <div style=" ;" class="flexItem paddingH8 font14r grey20">
                    {{dataItem.userName}}
                </div>
                <div class="grey60 font10r" style="width: 45px;">
                    {{formatDate(dataItem.createTime)}}
                </div>
            </div>
            <div class="marginT12 font13r" style="
                line-height: 1.692em;
                color: #2C2C2C;
                font-size: 14px;
                font-weight: 400;
                margin-left:32px;
                ">
                {{dataItem.content}}
            </div>
        </div>
    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import moment from 'moment';

// config
import appConfig from '../../appConfig';

// util
import objectHelper from '@util/objectHelper';

const config = {
    apiConfig : {
        list : {
            url : 'portal/audio/comment/list',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    },
    demoTitleList : [
        '园长“苦恼”，幼儿园之间到底在竞争什么',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            apiConfig : config.apiConfig,
            // pageSize : 8,
            // autoLoadData : appConfig.mode != 'demo'
        }
    },
    methods : {
        updateDataList(params) {
            let apiParams = this.apiConfig.list.params || {};
            apiParams = objectHelper.merge(apiParams, params);
            this.apiConfig.list.params = apiParams;
            this.reloadDataList();
        },
        formatDate(timestamp) {
            return moment(timestamp).format('MM-DD')
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
